import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserContextService } from '@sentry/user-context';
import { PermissionCode } from './permission-code';

@UntilDestroy()
@Directive({
    selector: '[sentryHasPermission]',
    standalone: true
})
export class HasPermissionDirective {
  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private readonly userContextService: UserContextService
  ) {}

  @Input() set sentryHasPermission(permissionCode: PermissionCode) {
    this.userContextService.permissions$
      .pipe(untilDestroyed(this))
      .subscribe((permissions) => {
        const hasPermission = permissions.some(
          (p) => p.code === permissionCode
        );

        if (hasPermission) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      });
  }
}
